export default "__VITE_ASSET__CCCuOYWm__"